import React from "react"
import StackingContentBlock from "@/components/StackingContentBlock"

const StackingContentContainer = ({
  blocks,
  title,
  subheading,
  spacingClass = "",
}) => {
  return (
    <div
      className={`stacking__content bg-grey  ${spacingClass || "pb-16 pt-16 md:pb-30 md:pt-16"}`}
    >
      <div className="container-fluid">
        <h2 className="h1 text-centered">{title}</h2>
        <p className="col-xs-12 col-md-8 col-md-offset-2 p--lg mb-0 text-centered">
          {subheading}
        </p>
        {/* Cards */}
        <div className="stacking__content-blocks">
          {blocks.map((block, index) => (
            <StackingContentBlock
              key={index}
              index={index}
              kicker={block.kicker}
              title={block.title}
              description={block.description}
              image={block.image}
              playlistId={block.playlistId}
              link={block.link}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default StackingContentContainer
